import script from "./CampaignsManagementSendLimit.vue?vue&type=script&lang=ts&setup=true"
export * from "./CampaignsManagementSendLimit.vue?vue&type=script&lang=ts&setup=true"

import "./CampaignsManagementSendLimit.vue?vue&type=style&index=0&id=6b6af9a8&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b6af9a8"]])

export default __exports__